import { gql } from '@apollo/client/index.js'

export const QUOTE_WIZARD_ASSET_PARTIAL = `
quoteWizardAsset: asset(id: $qwAssetId, locale: $locale, preview: $preview) {
  originalWidth : width
  originalHeight : height
  title
  url
  size
  description
}
`

export const QUOTE_WIZARD_ASSET_QUERY = gql`
  query quoteWizardAsset($qwAssetId: String! $locale: String! $preview: Boolean!) {
    ${QUOTE_WIZARD_ASSET_PARTIAL}
  }
`
